import React from "react";
import { useRouter } from "next/router";
import { Autocomplete, Icon, Layout, TextField } from "@shopify/polaris";
import { SearchMinor } from "@shopify/polaris-icons";
import { Search } from "@usereactify/search";
import { useAppContext } from "~/providers/app";
import { Sort } from "./sort";

export const Actions = () => {
  const { isCollection, isSearch, urlHandle } = useAppContext();

  if (isCollection) {
    return (
      <Layout>
        <Layout.Section oneHalf={Boolean(urlHandle)}>
          <div className="Polaris-Collection-Selector">
            <CollectionInput />
          </div>
        </Layout.Section>
        {urlHandle ? (
          <Layout.Section oneHalf>
            <Sort />
          </Layout.Section>
        ) : null}
      </Layout>
    );
  }

  if (isSearch) {
    return (
      <Layout>
        <Layout.Section oneHalf>
          <Search
            render={(renderProps) => (
              <TextField
                autoComplete="no"
                label="Search"
                labelHidden
                prefix={<Icon source={SearchMinor} color="base" />}
                placeholder="Search for products"
                value={renderProps.searchTerm}
                onChange={(value) => renderProps.setSearchTerm(value)}
              />
            )}
          />
        </Layout.Section>
        <Layout.Section oneHalf>
          <Sort />
        </Layout.Section>
      </Layout>
    );
  }

  return <></>;
};

const CollectionInput = () => {
  const router = useRouter();
  const { collections } = useAppContext();
  const [loading, setLoading] = React.useState(false);
  const [inputValue, setInputValue] = React.useState("");
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const deselectedOptions = React.useMemo(
    () => collections.map((collection) => ({ value: collection, label: collection })),
    [collections]
  );
  const [options, setOptions] = React.useState(deselectedOptions);

  const handleUpdate = React.useCallback(
    (value: string) => {
      setInputValue(value);

      if (!loading) {
        setLoading(true);
      }

      setTimeout(() => {
        if (value === "") {
          setOptions(deselectedOptions);
          setLoading(false);
          return;
        }
        const filterRegex = new RegExp(value, "i");
        const resultOptions = deselectedOptions.filter((option) => option.label.match(filterRegex));
        setOptions(resultOptions);
        setLoading(false);
      }, 300);
    },
    [deselectedOptions, loading]
  );

  const handleSelection = React.useCallback(
    (selected: string[]) => {
      setSelectedOptions([]);
      setInputValue("");
      router.push(`/collections/${selected[0].toLowerCase().replace(" ", "-").replace("'", "")}`);
    },
    [router]
  );

  return (
    <Autocomplete
      options={options}
      loading={loading}
      selected={selectedOptions}
      onSelect={handleSelection}
      textField={
        <Autocomplete.TextField
          label=""
          autoComplete="on"
          placeholder="Search for collection handle"
          value={inputValue}
          onChange={handleUpdate}
          prefix={<Icon source={SearchMinor} color="base" />}
        />
      }
    />
  );
};
